/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */
import React from "react";
import FormFader from "../../Common/Fader/FormFader";
import wizardStyle from "../../wizardStyle";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { Button, Typography } from "@mui/material";
import FormLegend from "../FormLegend/FormLegend";
import { Link } from "react-router";
import { getCaseLink } from "../../../../services/productService";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";

type RecordingConsentSuccessProps = {
  product?: AbstractCase;
};

export default function RecordingConsentSuccess({ product }: RecordingConsentSuccessProps) {
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Grid
          container
          sx={{
            justifyContent: "center",
            alignItems: "baseline"
          }}>
          <Grid size={12}>
            <FormLegend>
              <strong>Vielen Dank für Ihre Auswahl</strong>
            </FormLegend>
          </Grid>
          <Grid size={12}>
            <Typography sx={{ textAlign: "center", my: "2rem" }}>Sie können Ihre Entscheidung jederzeit in Ihrer Servicewelt ändern.</Typography>
          </Grid>
          <Grid
            sx={{ paddingTop: "1rem", paddingBottom: "2rem" }}
            size={{
              xs: 12,
              sm: 6
            }}>
            <Button fullWidth variant={"contained"} component={Link} to={product ? getCaseLink(product) : "/servicewelt"}>
              Zurück zur Servicewelt
            </Button>
          </Grid>
        </Grid>
      </FormFader>
    </Paper>
  );
}
